import React from "react";
import { connect } from "react-redux";

//Customand and  utils
import stringValues from "../../stringValues";
import { images } from "../../imageValues";
import Button from "../../component/Button/Button";
import { AxlTracker, playSound } from "../../utils";

// Animation
import thinking from "../../assets/lottieAnimation/Thinking.json";

//Custom styled
import {
  LottieAnimation,
  Bottom,
  CenterAreaOne,
  Header,
  Logo,
  LogoDiv,
  SubTitle,
  BeginTitle,
  LottieAnimationDiv,
  P,
} from "./BeginStyled";
import { useAxL } from "../../AxLContext";

const Begin = ({ changeLanguageState, onChange, playPauseSoundState }) => {
  const mobileWidth = window.innerWidth;
  const axl = useAxL();
  return (
    <>
      <CenterAreaOne>
        <Header>
          <span style={{ fontSize: 22 }}>
            {stringValues[changeLanguageState.data].harshitAgrawal}
          </span>
          <br />
          <SubTitle style={{ marginTop: "10px" }}>
            {stringValues[changeLanguageState.data].presents}
          </SubTitle>
          <h3 style={{ margin: 0 }}>
            {stringValues[changeLanguageState.data].gameTitle}
          </h3>
          <BeginTitle
            src={
              changeLanguageState.data === "en"
                ? images.MATCHBOXMOMENTOS
                : images.MATCHBOXMOMENTOSHINDI
            }
            isEnglish={changeLanguageState.data === "en" ? true : false}
          />
          <br />
          <br />
          <div style={{ display: "flex" }}>
            <Bottom>
              {stringValues[changeLanguageState.data].journeyTutorial1}
            </Bottom>
          </div>
          <LottieAnimationDiv>
            <LottieAnimation
              style={{ height: 120, width: 120, marginTop: 30 }}
              animationData={thinking}
            />
          </LottieAnimationDiv>
        </Header>
      </CenterAreaOne>

      <Button
        label={stringValues[changeLanguageState.data].startCollecting}
        onClick={() => {
          onChange();
          playSound(playPauseSoundState);
          AxlTracker(axl, "Clicked Start", "Start", 1, true);
        }}
        style={{
          backgroundColor: "#F8C933",
          marginBottom: mobileWidth > 1080 ? 40 : 20,
          color: "#89202b",
        }}
      />
      <SubTitle style={{ marginTop: "10px" }}>
        {stringValues[changeLanguageState.data].inCollaborationWith}
      </SubTitle>
      <LogoDiv>
        <Logo
          src={
            changeLanguageState.data === "en"
              ? images.MAP_LOGO
              : images.MAP_LOGO
          }
        />
        <Logo
          src={
            changeLanguageState.data === "en"
              ? images.TASVEER_GHAR_LOGO
              : images.TASVEER_GHAR_LOGO
          }
        />
        <Logo
          src={changeLanguageState.data === "en" ? images.Logo : images.Logo}
        />
      </LogoDiv>
      {mobileWidth > 1080 ? (
        <P
          style={{
            marginTop:
              stringValues[changeLanguageState.data] === "en" ? 0 : -20,
          }}
        >
          {stringValues[changeLanguageState.data].mobileOptimized}
        </P>
      ) : (
        <></>
      )}
    </>
  );
};
const mapStateToProps = (state) => ({
  playPauseSoundState: state.playPauseSound,
  changeLanguageState: state.changeLanguage,
});

export default connect(mapStateToProps, null)(Begin);
